//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Footer from '../components/footer.vue'
import {
  MemberPreshiftQuery
} from '../../static/js/api.js'

export default {
  name: 'app',
  components: {
    'pc-footer': Footer,
  },
  data() {
    return {

        loading:true,
      data: {
        ShiftCode: {},
        ShiftDate: {},
        PayModeDetails: {}
      },
      value1: '2019-04-12',
      value2: '2019-05-12',
      msg: 'Welcome to Your Vue.js App',
      showContent001: false,
      showContent002: false,
      showContent003: false,
      showContent004: false,
      showContent005: false,
      showContent006: false,
        selected:1,

        nav:[
            {
                id:1,
                name:"付款明细"

            },



        ],
    }
  },
  created() {
    var that = this
    MemberPreshiftQuery({}, function (res) {
      console.log(res)
      if (res.data.IsSuccess) {

        that.data = JSON.parse(res.data.Result)
        if(that.data == null){
          that.$vux.toast.text('当前没有数据')
        }
        console.log(that.data)
      } else {

        that.$vux.toast.text('数据获取失败，请重试', 'middle')

      }


    })


  },

  methods: {
      change(index){
          console.log(index)
          this.selected= parseInt(index+1)

      },
  }
}



// WEBPACK FOOTER //
// ./src/pages/hjjiaoban.vue